import { useState } from "react";
import { useEinzugswegSetzen } from "../hooks/useLastschrift";
import type { Einzugsweg } from "../hooks/useLastschrift";
import { fehlertext } from "../lib/fehler";

const WEGE: { weg: Einzugsweg; titel: string; text: string }[] = [
  {
    weg: "aus",
    titel: "Aus — nur Überweisung",
    text: "Kunden zahlen per Überweisung. Offene Angebote zeigen die Lastschrift nicht mehr an.",
  },
  {
    weg: "datei",
    titel: "Einzugsdatei über die Sparkasse",
    text: "Der Kunde gibt IBAN und Mandat bei uns an. Fällige Raten gehen als Datei ins Online-Banking. Braucht die Inkassovereinbarung der Sparkasse.",
  },
  {
    weg: "qonto",
    titel: "Über Qonto",
    text: "Der Kunde unterschreibt das Mandat auf Qontos Seite. Braucht Qontos Freischaltung für den Lastschrifteinzug.",
  },
];

/**
 * Welcher Weg die Raten einzieht — die eine Einstellung dafür
 * (company.yaml → lastschrift_weg, Backend `lastschrift_weg.py`).
 *
 * Umstellen braucht einen zweiten Klick: es ändert sofort, was jedes offene
 * Angebot dem Kunden zeigt.
 */
export default function EinzugswegKarte({ weg }: { weg: Einzugsweg | undefined }) {
  const setzen = useEinzugswegSetzen();
  const [wahl, setWahl] = useState<Einzugsweg | null>(null);
  const aktuell = WEGE.find(w => w.weg === weg);

  return (
    <div className="pf-card ls-karte">
      <div className="ls-kopf">
        <span className="ls-titel">Einzugsweg</span>
        {aktuell && <span className={`ls-marke ${weg === "aus" ? "ls-offen" : "ls-gut"}`}>{aktuell.titel}</span>}
      </div>
      {aktuell && <p className="ls-text">{aktuell.text}</p>}
      <div className="ls-knoepfe">
        {WEGE.filter(w => w.weg !== weg).map(w => (
          <button key={w.weg} type="button" className="pf-btn is-ghost ls-knopf"
            disabled={setzen.isPending} onClick={() => setWahl(w.weg)}>
            Umstellen auf: {w.titel}
          </button>
        ))}
      </div>
      {wahl && (
        <div className="ls-knoepfe">
          <span className="ls-text ls-frage">
            {wahl === "aus"
              ? "Offene Angebote bieten dann keine Lastschrift mehr an. Geschlossene Verträge bleiben, wie sie sind."
              : "Offene Angebote bieten die Lastschrift ab sofort an. Wirklich umstellen?"}
          </span>
          <button type="button" className="pf-btn ls-knopf" disabled={setzen.isPending}
            onClick={() => setzen.mutate(wahl, { onSuccess: () => setWahl(null) })}>
            {setzen.isPending ? "Stellt um…" : "Ja, umstellen"}
          </button>
          <button type="button" className="pf-btn is-ghost ls-knopf" onClick={() => setWahl(null)}>
            Abbrechen
          </button>
        </div>
      )}
      {setzen.error && <p className="ls-fehler">{fehlertext(setzen.error)}</p>}
    </div>
  );
}
